// A generic undo manager that stores state snapshots.
class $b7ca4f3eb181cca1$export$932a3f9a7e88971c {
    constructor(initialState){
        this.undoStack = [];
        this.redoStack = [];
        this.currentState = this.deepCopy(initialState);
    }
    deepCopy(state) {
        return JSON.parse(JSON.stringify(state));
    }
    execute(newState) {
        this.undoStack.push(this.deepCopy(this.currentState));
        this.currentState = this.deepCopy(newState);
        this.redoStack = []; // clear redo on new action
    }
    undo() {
        if (!this.undoStack.length) return null;
        this.redoStack.push(this.deepCopy(this.currentState));
        this.currentState = this.undoStack.pop();
        return this.deepCopy(this.currentState);
    }
    redo() {
        if (!this.redoStack.length) return null;
        this.undoStack.push(this.deepCopy(this.currentState));
        this.currentState = this.redoStack.pop();
        return this.deepCopy(this.currentState);
    }
    getState() {
        return this.deepCopy(this.currentState);
    }
    canUndo() {
        return this.undoStack.length > 0;
    }
    canRedo() {
        return this.redoStack.length > 0;
    }
}


const $82e871fd2d479e13$export$339865da272fdb1c = [
    {
        name: 'ACCEPTANCE',
        description: 'to be accepted as I am'
    },
    {
        name: 'ACCURACY',
        description: 'to be accurate in my opinions and beliefs'
    },
    {
        name: 'ACHIEVEMENT',
        description: 'to have important accomplishments'
    },
    {
        name: 'ADVENTURE',
        description: 'to have new and exciting experiences'
    },
    {
        name: 'ALIVENESS',
        description: 'to follow resonance and vitality in making choices'
    },
    {
        name: 'ATTRACTIVENESS',
        description: 'to be physically attractive'
    },
    {
        name: 'AUTHORITY',
        description: 'to be in charge of and responsible for others'
    },
    {
        name: 'AUTONOMY',
        description: 'to be self-determined and independent'
    },
    {
        name: 'BEAUTY',
        description: 'to appreciate beauty around me'
    },
    {
        name: 'CARING',
        description: 'to take care of others'
    },
    {
        name: 'CHALLENGE',
        description: 'to take on difficult tasks and problems'
    },
    {
        name: 'CHANGE',
        description: 'to have a life full of change and variety'
    },
    {
        name: 'COLLABORATION',
        description: 'to work with others for a common purpose or good'
    },
    {
        name: 'COMFORT',
        description: 'to have a pleasant and comfortable life'
    },
    {
        name: 'COMMITMENT',
        description: 'to make enduring, meaningful commitments'
    },
    {
        name: 'COMPASSION',
        description: 'to feel and act on concern for others'
    },
    {
        name: 'CONTRIBUTION',
        description: 'to make a lasting contribution in the world'
    },
    {
        name: 'COOPERATION',
        description: 'to work collaboratively with others'
    },
    {
        name: 'COURAGE',
        description: 'to have a mind or spirit that enables you to face difficulty with bravery'
    },
    {
        name: 'COURTESY',
        description: 'to be considerate and polite toward others'
    },
    {
        name: 'CREATIVITY',
        description: 'to have new and original ideas'
    },
    {
        name: 'DEPENDABILITY',
        description: 'to be reliable and trustworthy'
    },
    {
        name: 'DUTY',
        description: 'to carry out my duties and obligations'
    },
    {
        name: 'ECOLOGY',
        description: 'to live in harmony with the environment'
    },
    {
        name: 'EXCITEMENT',
        description: 'to have a life full of thrills and stimulation'
    },
    {
        name: 'FAITHFULNESS',
        description: 'to be loyal and true in relationships'
    },
    {
        name: 'FAME',
        description: 'to be known and recognized'
    },
    {
        name: 'FAMILY',
        description: 'to have a happy, loving family'
    },
    {
        name: 'FITNESS',
        description: 'to be physically fit and strong'
    },
    {
        name: 'FLEXIBILITY',
        description: 'to adjust to new circumstances easily'
    },
    {
        name: 'FORGIVENESS',
        description: 'to be forgiving of others'
    },
    {
        name: 'FRIENDSHIP',
        description: 'to have close, supportive friends'
    },
    {
        name: 'FUN',
        description: 'to play and have fun'
    },
    {
        name: 'GENEROSITY',
        description: 'to give what I have to others'
    },
    {
        name: 'GENUINENESS',
        description: 'to act in a manner that is true to who I am'
    },
    {
        name: "GOD'S WILL",
        description: 'to seek and obey the will of God'
    },
    {
        name: 'GROWTH',
        description: 'to keep changing and growing'
    },
    {
        name: 'HEALTH',
        description: 'to live in ways that promote overall health and vigor'
    },
    {
        name: 'HELPFULNESS',
        description: 'to be helpful to others'
    },
    {
        name: 'HONESTY',
        description: 'to be honest and truthful'
    },
    {
        name: 'HOPE',
        description: 'to maintain a positive and optimistic outlook'
    },
    {
        name: 'HUMILITY',
        description: 'to be modest and unassuming'
    },
    {
        name: 'HUMOR',
        description: 'to see the humorous side of myself and the world'
    },
    {
        name: 'INDEPENDENCE',
        description: 'to be free from dependence on others'
    },
    {
        name: 'INDUSTRY',
        description: 'to work hard and well at my life tasks'
    },
    {
        name: 'INNER PEACE',
        description: 'to experience personal peace'
    },
    {
        name: 'INTIMACY',
        description: 'to share my innermost experiences with others'
    },
    {
        name: 'INTUITION',
        description: 'to have and to trust your own judgement'
    },
    {
        name: 'JUSTICE',
        description: 'to promote fair and equal treatment for all'
    },
    {
        name: 'KINDNESS',
        description: 'to be warm, considerate and benevolent toward others'
    },
    {
        name: 'KNOWLEDGE',
        description: 'to learn and contribute valuable knowledge'
    },
    {
        name: 'LEISURE',
        description: 'to take time to relax and enjoy'
    },
    {
        name: 'LOVED',
        description: 'to be loved by those close to me'
    },
    {
        name: 'LOVING',
        description: 'to give love to others'
    },
    {
        name: 'MASTERY',
        description: 'to be competent in my everyday activities'
    },
    {
        name: 'MINDFULNESS',
        description: 'to live consciously and mindfully of the present moment'
    },
    {
        name: 'MODERATION',
        description: 'to avoid excesses and find a middle ground'
    },
    {
        name: 'MONOGAMY',
        description: 'to have one close, loving relationship'
    },
    {
        name: 'NONCONFORMITY',
        description: 'to question and challenge authority and norms'
    },
    {
        name: 'NURTURANCE',
        description: 'to take care of and nurture others'
    },
    {
        name: 'OPENNESS',
        description: 'to be open to new experiences, ideas, and options'
    },
    {
        name: 'ORDER',
        description: 'to have a life that is well-ordered and organized'
    },
    {
        name: 'PASSION',
        description: 'to have deep feelings about ideas, activities, or people'
    },
    {
        name: 'PLEASURE',
        description: 'to feel good'
    },
    {
        name: 'POPULARITY',
        description: 'to be recognized and well-liked by many people'
    },
    {
        name: 'POWER',
        description: 'to have control over others'
    },
    {
        name: 'PURPOSE',
        description: 'to have meaning and direction in my life'
    },
    {
        name: 'RATIONALITY',
        description: 'to be guided by reason and logic'
    },
    {
        name: 'REALISM',
        description: 'to see and act realistically and practically'
    },
    {
        name: 'RESILIENCE',
        description: 'to recover quickly from difficulties'
    },
    {
        name: 'RESPONSIBILITY',
        description: 'to make and carry out responsible decisions'
    },
    {
        name: 'RISK',
        description: 'to take risks and chances'
    },
    {
        name: 'ROMANCE',
        description: 'to have intense, exciting love in my life'
    },
    {
        name: 'SAFETY',
        description: 'to be safe and secure'
    },
    {
        name: 'SELF-ACCEPTANCE',
        description: 'to accept myself as I am'
    },
    {
        name: 'SELF-CONTROL',
        description: 'to be disciplined in my own actions'
    },
    {
        name: 'SELF-ESTEEM',
        description: 'to feel good about myself'
    },
    {
        name: 'SELF-KNOWLEDGE',
        description: 'to have a deep and honest understanding of myself'
    },
    {
        name: 'SERVICE',
        description: 'to be of service to others'
    },
    {
        name: 'SEXUALITY',
        description: 'to have an active and satisfying sex life'
    },
    {
        name: 'SIMPLICITY',
        description: 'to live life simply, with minimal needs'
    },
    {
        name: 'SOCIAL CONNECTION',
        description: 'to prioritize close and ongoing relationship with other people'
    },
    {
        name: 'SOLITUDE',
        description: 'to have time and space where I can be apart from others'
    },
    {
        name: 'SPIRITUALITY',
        description: 'to grow and mature spiritually'
    },
    {
        name: 'STABILITY',
        description: 'to have a life that stays fairly consistent'
    },
    {
        name: 'TOLERANCE',
        description: 'to accept and respect those who differ from me'
    },
    {
        name: 'TRADITION',
        description: 'to follow respected patterns of the past'
    },
    {
        name: 'VIRTUE',
        description: 'to live a morally pure and excellent life'
    },
    {
        name: 'VULNERABILITY',
        description: 'to honor uncertainty, risk and emotional exposure in yourself and others'
    },
    {
        name: 'WEALTH',
        description: 'to have plenty of money'
    },
    {
        name: 'WISDOM',
        description: 'to have deep insight, knowledge and judgement'
    },
    {
        name: 'WORLD PEACE',
        description: 'to work to promote peace in the world'
    }
];


const $543d6d2a56ed7d8d$var$ICONS = {
    warning: "\u26A0",
    error: "\u2715",
    success: "\u2713",
    info: '!'
};
function $543d6d2a56ed7d8d$var$showModal(options) {
    return new Promise((resolve)=>{
        const modal = document.getElementById('alertModal');
        const icon = document.getElementById('alertIcon');
        const title = document.getElementById('alertTitle');
        const message = document.getElementById('alertMessage');
        const confirmBtn = document.getElementById('alertConfirmBtn');
        const cancelBtn = document.getElementById('alertCancelBtn');
        const type = options.type ?? 'info';
        // Set content
        icon.className = `alert-icon ${type}`;
        icon.textContent = $543d6d2a56ed7d8d$var$ICONS[type];
        title.textContent = options.title;
        message.textContent = options.message;
        confirmBtn.textContent = options.confirmText ?? 'OK';
        cancelBtn.textContent = options.cancelText ?? 'Cancel';
        cancelBtn.style.display = options.showCancel ? 'inline-block' : 'none';
        // Show modal
        modal.style.display = 'flex';
        // Focus confirm button
        setTimeout(()=>{
            confirmBtn.focus();
        }, 50);
        // Cleanup function
        const cleanup = ()=>{
            modal.style.display = 'none';
            confirmBtn.removeEventListener('click', onConfirm);
            cancelBtn.removeEventListener('click', onCancel);
            modal.removeEventListener('click', onBackdrop);
            document.removeEventListener('keydown', onKeydown);
        };
        const onConfirm = ()=>{
            cleanup();
            resolve(true);
        };
        const onCancel = ()=>{
            cleanup();
            resolve(false);
        };
        const onBackdrop = (e)=>{
            if (e.target === modal) {
                cleanup();
                resolve(false);
            }
        };
        const onKeydown = (e)=>{
            if (e.key === 'Escape') {
                cleanup();
                resolve(false);
            } else if (e.key === 'Enter') {
                cleanup();
                resolve(true);
            }
        };
        confirmBtn.addEventListener('click', onConfirm);
        cancelBtn.addEventListener('click', onCancel);
        modal.addEventListener('click', onBackdrop);
        document.addEventListener('keydown', onKeydown);
    });
}
// Convenience functions
function $543d6d2a56ed7d8d$var$showAlert(title, message, type = 'info') {
    return $543d6d2a56ed7d8d$var$showModal({
        title: title,
        message: message,
        type: type
    });
}
function $543d6d2a56ed7d8d$var$showConfirm(title, message, type = 'warning') {
    return $543d6d2a56ed7d8d$var$showModal({
        title: title,
        message: message,
        type: type,
        showCancel: true,
        confirmText: 'Yes',
        cancelText: 'No'
    });
}
// Recreate ALL_VALUES and LIMITED_VALUES based on the import
const $543d6d2a56ed7d8d$var$ALL_VALUE_DEFINITIONS = (0, $82e871fd2d479e13$export$339865da272fdb1c);
const $543d6d2a56ed7d8d$var$LIMITED_VALUE_DEFINITIONS = $543d6d2a56ed7d8d$var$ALL_VALUE_DEFINITIONS.slice(0, 10);
// Create a global map for easy description lookup
const $543d6d2a56ed7d8d$var$valueDefinitionsMap = new Map($543d6d2a56ed7d8d$var$ALL_VALUE_DEFINITIONS.map((def)=>[
        def.name,
        def.description
    ]));
class $543d6d2a56ed7d8d$export$86fbec116b87613f {
    constructor(){
        this.storageKey = 'valuesExerciseState';
        this.nextCustomCardId = -1 // Counter for unique negative IDs
        ;
        this.selectedCardId = null // For mobile tap-to-move
        ;
        // Load state from localStorage or initialize default state.
        const saved = localStorage.getItem(this.storageKey);
        let initialState;
        if (saved) try {
            initialState = JSON.parse(saved);
            // Ensure editing state is null initially
            initialState.editingDescriptionCardId = null;
            const minId = Math.min(0, ...initialState.cards.filter((c)=>c.isCustom).map((c)=>c.id));
            this.nextCustomCardId = minId - 1;
        } catch  {
            initialState = this.defaultState('all');
            this.nextCustomCardId = -1; // Reset on error
        }
        else {
            initialState = this.defaultState('all');
            this.nextCustomCardId = -1; // Reset if no saved state
        }
        this.state = initialState;
        this.undoManager = new (0, $b7ca4f3eb181cca1$export$932a3f9a7e88971c)(this.state);
        this.bindEventListeners();
        this.render();
        this.updateUndoRedoButtons();
    }
    // Default state with sample value cards based on the selected set
    defaultState(valueSet = 'all') {
        const definitionsToUse = valueSet === 'all' ? $543d6d2a56ed7d8d$var$ALL_VALUE_DEFINITIONS : $543d6d2a56ed7d8d$var$LIMITED_VALUE_DEFINITIONS;
        const sampleCards = definitionsToUse.map((definition, index)=>({
                id: index + 1,
                name: definition.name,
                column: 'unassigned',
                order: index,
                description: undefined,
                isCustom: false
            }));
        return {
            currentPart: 'part1',
            cards: sampleCards,
            finalStatements: {},
            valueSet: valueSet,
            editingDescriptionCardId: null
        };
    }
    // Save the state to localStorage.
    saveState() {
        localStorage.setItem(this.storageKey, JSON.stringify(this.state));
    }
    // Update state via the undoManager then re-render.
    updateState(newState) {
        this.undoManager.execute(newState);
        this.state = this.undoManager.getState();
        this.saveState();
        this.render();
        this.updateUndoRedoButtons();
    }
    // Method to toggle between limited and all values
    toggleValueSet() {
        const currentState = this.undoManager.getState();
        const nextSet = currentState.valueSet === 'limited' ? 'all' : 'limited';
        // Generate a fresh default state for the *new* set, resetting progress
        const newState = this.defaultState(nextSet);
        // Execute this change through the undo manager
        this.updateState(newState);
    }
    // --- Add Value Form Logic ---
    showAddValueForm() {
        const form = document.getElementById('addValueForm');
        const nameInput = document.getElementById('newValueName');
        const descInput = document.getElementById('newValueDesc');
        if (form && nameInput && descInput) {
            nameInput.value = ''; // Clear previous input
            descInput.value = '';
            form.style.display = 'flex'; // Show the modal
            nameInput.focus(); // Focus the name input
        }
    }
    hideAddValueForm() {
        const form = document.getElementById('addValueForm');
        if (form) form.style.display = 'none'; // Hide the modal
    }
    async saveNewValue() {
        const nameInput = document.getElementById('newValueName');
        const descInput = document.getElementById('newValueDesc');
        const name = nameInput?.value.trim().toUpperCase(); // Normalize name
        const description = descInput?.value.trim();
        if (!name) {
            await $543d6d2a56ed7d8d$var$showAlert('Missing Name', 'Please enter a name for the new value.', 'warning');
            nameInput?.focus();
            return;
        }
        if (!description) {
            await $543d6d2a56ed7d8d$var$showAlert('Missing Description', 'Please enter a description for the new value.', 'warning');
            descInput?.focus();
            return;
        }
        const newState = this.undoManager.getState();
        // Check for duplicates (case-insensitive)
        if (newState.cards.some((card)=>card.name.toUpperCase() === name)) {
            await $543d6d2a56ed7d8d$var$showAlert('Duplicate Value', `A value named "${name}" already exists.`, 'error');
            nameInput?.focus();
            return;
        }
        // Create new card
        const newCard = {
            id: this.nextCustomCardId,
            name: name,
            description: description,
            column: 'unassigned',
            order: 0,
            isCustom: true
        };
        this.nextCustomCardId--; // Decrement for next custom card
        // Add the new card
        newState.cards.push(newCard);
        // Sort only unassigned cards alphabetically, preserve order in other columns
        const unassignedCards = newState.cards.filter((c)=>c.column === 'unassigned');
        unassignedCards.sort((a, b)=>a.name.localeCompare(b.name));
        unassignedCards.forEach((card, index)=>{
            card.order = index;
        });
        // Sort entire array so unassigned cards render in alphabetical order
        newState.cards.sort((a, b)=>{
            if (a.column === 'unassigned' && b.column === 'unassigned') return a.name.localeCompare(b.name);
            return a.order - b.order;
        });
        this.updateState(newState);
        this.hideAddValueForm();
    }
    // --- Description Edit Logic ---
    startEditingDescription(cardId) {
        const newState = this.undoManager.getState();
        newState.editingDescriptionCardId = cardId;
        this.updateState(newState); // Re-render to show the textarea
    }
    saveDescriptionEdit(cardId, newDescription) {
        const newState = this.undoManager.getState();
        const cardToUpdate = newState.cards.find((c)=>c.id === cardId);
        if (cardToUpdate) cardToUpdate.description = newDescription.trim(); // Save trimmed description
        newState.editingDescriptionCardId = null; // Stop editing
        this.updateState(newState);
    }
    cancelDescriptionEdit() {
        const newState = this.undoManager.getState();
        newState.editingDescriptionCardId = null; // Just stop editing, don't save
        this.updateState(newState);
    }
    // Bind event listeners for UI interactions.
    bindEventListeners() {
        // Remove alias: Arrow functions capture 'this' correctly
        // const appInstance = this;
        // --- Add Value Form Listeners ---
        document.getElementById('showAddValueFormBtn')?.addEventListener('click', ()=>{
            this.showAddValueForm();
        });
        document.getElementById('saveNewValueBtn')?.addEventListener('click', ()=>{
            this.saveNewValue();
        });
        document.getElementById('cancelNewValueBtn')?.addEventListener('click', ()=>{
            this.hideAddValueForm();
        });
        // Close modal if clicking outside the content
        document.getElementById('addValueForm')?.addEventListener('click', (e)=>{
            if (e.target === e.currentTarget) this.hideAddValueForm();
        });
        // Navigation buttons
        document.getElementById('toPart2')?.addEventListener('click', ()=>{
            (async ()=>{
                const newState = this.undoManager.getState();
                // Check for unassigned cards before proceeding
                const unassignedCount = newState.cards.filter((card)=>card.column === 'unassigned').length;
                if (unassignedCount > 0) {
                    await $543d6d2a56ed7d8d$var$showAlert('Sort All Values', `Please sort all ${unassignedCount} unassigned value(s) before proceeding to Part 2.`, 'warning');
                    return;
                }
                newState.currentPart = 'part2';
                newState.cards = newState.cards.filter((card)=>card.column === 'veryImportant').map((card)=>({
                        ...card,
                        column: 'unassigned'
                    }));
                this.updateState(newState); // Call updateState directly
            })();
        });
        document.getElementById('toPart3')?.addEventListener('click', ()=>{
            (async ()=>{
                const newState = this.undoManager.getState();
                // Check for unassigned cards before proceeding
                const unassignedCount = newState.cards.filter((card)=>card.column === 'unassigned').length;
                if (unassignedCount > 0) {
                    await $543d6d2a56ed7d8d$var$showAlert('Sort All Values', `Please sort all ${unassignedCount} unassigned value(s) before proceeding.`, 'warning');
                    return;
                }
                const veryImportantCards = newState.cards.filter((c)=>c.column === 'veryImportant');
                const veryImportantCount = veryImportantCards.length;
                if (veryImportantCount <= 5) newState.currentPart = 'part4';
                else newState.currentPart = 'part3';
                // Move all "veryImportant" cards to "core" regardless of the next part
                newState.cards = veryImportantCards.map((c, idx)=>({
                        ...c,
                        column: 'core',
                        order: idx
                    }));
                this.updateState(newState); // Call updateState directly
            })();
        });
        document.getElementById('toPart4')?.addEventListener('click', ()=>{
            (async ()=>{
                const newState = this.undoManager.getState();
                const coreCount = newState.cards.filter((c)=>c.column === 'core').length;
                if (coreCount > 5) {
                    await $543d6d2a56ed7d8d$var$showAlert('Too Many Core Values', "You can only have 5 core values. Please move some values to 'Also Something I Want' before continuing.", 'warning');
                    return; // Don't update state if validation fails
                }
                newState.currentPart = 'part4';
                this.updateState(newState); // Call updateState directly
            })();
        });
        document.getElementById('finish')?.addEventListener('click', ()=>{
            (async ()=>{
                const newState = this.undoManager.getState();
                // Check if all core values have statements
                const coreCards = newState.cards.filter((c)=>c.column === 'core');
                const missingStatements = coreCards.filter((card)=>!newState.finalStatements[card.id]?.trim());
                if (missingStatements.length > 0) {
                    await $543d6d2a56ed7d8d$var$showAlert('Missing Statements', `Please provide a statement for all core values. Missing: ${missingStatements.map((c)=>c.name).join(', ')}`, 'warning');
                    return; // Prevent transition
                }
                // Original transition logic
                newState.currentPart = 'review';
                this.updateState(newState); // Call updateState directly
            })();
        });
        document.getElementById('restart')?.addEventListener('click', ()=>{
            const newState = this.defaultState();
            this.updateState(newState); // Call updateState directly
        });
        // --- Triple-click on title to toggle testing mode button ---
        const titleElement = document.querySelector('header h1');
        let clickCount = 0;
        let clickTimer = null;
        titleElement?.addEventListener('click', ()=>{
            clickCount++;
            if (clickTimer) clearTimeout(clickTimer);
            clickTimer = setTimeout(()=>{
                clickCount = 0;
            }, 500); // Reset after 500ms of no clicks
            if (clickCount >= 3) {
                clickCount = 0;
                const limitedBtn = document.getElementById('useLimitedValuesBtn');
                if (limitedBtn) {
                    const isHidden = limitedBtn.style.display === 'none';
                    limitedBtn.style.display = isHidden ? 'inline-block' : 'none';
                }
            }
        });
        // --- Listener for the testing mode toggle button ---
        document.getElementById('useLimitedValuesBtn')?.addEventListener('click', ()=>{
            (async ()=>{
                const currentSet = this.undoManager.getState().valueSet;
                if (currentSet !== 'limited') {
                    const confirmed = await $543d6d2a56ed7d8d$var$showConfirm('Switch to Testing Mode', 'Switching to testing mode (10 values) will reset your current progress. Are you sure?', 'warning');
                    if (confirmed) this.toggleValueSet();
                } else {
                    // Already in limited mode, switch back to all
                    const confirmed = await $543d6d2a56ed7d8d$var$showConfirm('Switch to Full Mode', 'Switching to full mode (all values) will reset your current progress. Are you sure?', 'warning');
                    if (confirmed) this.toggleValueSet();
                }
            })();
        });
        // Undo/Redo buttons
        document.getElementById('undoBtn')?.addEventListener('click', ()=>{
            const prev = this.undoManager.undo();
            if (prev) {
                this.state = prev;
                this.saveState();
                this.render();
                this.updateUndoRedoButtons();
            }
        });
        document.getElementById('redoBtn')?.addEventListener('click', ()=>{
            const next = this.undoManager.redo();
            if (next) {
                this.state = next;
                this.saveState();
                this.render();
                this.updateUndoRedoButtons();
            }
        });
        // Clear storage button (renamed to Restart exercise)
        document.getElementById('clearStorageBtn')?.addEventListener('click', ()=>{
            (async ()=>{
                const confirmed = await $543d6d2a56ed7d8d$var$showConfirm('Restart Exercise', 'Are you sure you want to restart? All progress will be lost. This action cannot be undone.', 'error');
                if (confirmed) {
                    localStorage.removeItem(this.storageKey);
                    // Reset to the default state using the *current* value set preference
                    const newState = this.defaultState(this.state.valueSet);
                    this.updateState(newState);
                }
            })();
        });
        // Set up drag and drop for card movement in all card-container elements.
        const containers = document.querySelectorAll('.card-container');
        containers.forEach((container)=>{
            container.addEventListener('dragover', (e)=>{
                e.preventDefault();
                container.classList.add('drag-over');
            });
            container.addEventListener('dragleave', (e)=>{
                // Only remove if we're leaving the container entirely
                const relatedTarget = e.relatedTarget;
                if (!container.contains(relatedTarget)) container.classList.remove('drag-over');
            });
            container.addEventListener('drop', (e)=>{
                e.preventDefault();
                container.classList.remove('drag-over');
                const dragEvent = e;
                const cardId = Number(dragEvent.dataTransfer?.getData('text/plain'));
                const targetColumn = container.parentElement.getAttribute('data-column');
                if (targetColumn) this.moveCard(cardId, targetColumn);
            });
            container.addEventListener('dragend', ()=>{
                // Clean up all drag-over states
                document.querySelectorAll('.card-container.drag-over').forEach((el)=>{
                    el.classList.remove('drag-over');
                });
            });
            // Mobile: click on container to move selected card
            container.addEventListener('click', (e)=>{
                // Only handle if a card is selected and click is directly on container (not on a card)
                if (this.selectedCardId !== null && e.target === container) {
                    const targetColumn = container.parentElement?.getAttribute('data-column');
                    if (targetColumn) {
                        this.moveCard(this.selectedCardId, targetColumn);
                        this.selectedCardId = null; // Clear selection after move
                    }
                }
            });
        });
    }
    // Moves a card (by id) to a new column.
    async moveCard(cardId, newColumn) {
        const newState = this.undoManager.getState();
        const card = newState.cards.find((c)=>c.id === cardId);
        if (card) {
            // If in Part3 and moving to the 'core' column, enforce a maximum of 5 core cards.
            if (newState.currentPart === 'part3' && newColumn === 'core') {
                const coreCount = newState.cards.filter((c)=>c.column === 'core').length;
                if (coreCount >= 5 && card.column !== 'core') {
                    await $543d6d2a56ed7d8d$var$showAlert('Limit Reached', 'You can only have 5 core values!', 'warning');
                    return;
                }
            }
            card.column = newColumn;
            // Optionally, update order if needed (here we simply set order to current timestamp).
            card.order = Date.now();
            this.updateState(newState);
        }
    }
    // Creates a draggable card element, handles description editing UI.
    createCardElement(card) {
        const cardElem = document.createElement('div');
        cardElem.className = 'card';
        cardElem.draggable = true;
        cardElem.dataset.cardId = card.id.toString();
        const nameElem = document.createElement('span');
        nameElem.className = 'card-name';
        nameElem.textContent = card.name;
        cardElem.appendChild(nameElem);
        // Container for description/edit area
        const descriptionContainer = document.createElement('div');
        descriptionContainer.className = 'card-description-container';
        if (this.state.editingDescriptionCardId === card.id) {
            // RENDER EDIT TEXTAREA
            const textarea = document.createElement('textarea');
            textarea.className = 'card-description-edit';
            textarea.value = card.description ?? $543d6d2a56ed7d8d$var$valueDefinitionsMap.get(card.name) ?? '';
            textarea.rows = 3;
            textarea.addEventListener('blur', ()=>{
                this.saveDescriptionEdit(card.id, textarea.value);
            });
            textarea.addEventListener('keydown', (e)=>{
                if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault(); // Prevent newline
                    this.saveDescriptionEdit(card.id, textarea.value);
                } else if (e.key === 'Escape') this.cancelDescriptionEdit();
            });
            descriptionContainer.appendChild(textarea);
            // Auto-focus the textarea after it's rendered
            setTimeout(()=>{
                textarea.focus();
            }, 0);
        } else {
            // RENDER DESCRIPTION TEXT (Clickable)
            const descriptionElem = document.createElement('span');
            descriptionElem.className = 'card-description clickable'; // Add clickable class
            descriptionElem.textContent = card.description ?? $543d6d2a56ed7d8d$var$valueDefinitionsMap.get(card.name) ?? '(Click to add description)';
            descriptionElem.title = 'Click to edit description'; // Tooltip
            descriptionElem.addEventListener('click', (e)=>{
                e.stopPropagation(); // Prevent card drag start if clicking text
                this.toggleCardSelection(card.id); // Also select card to show drop zones
                this.startEditingDescription(card.id);
            });
            descriptionContainer.appendChild(descriptionElem);
        }
        cardElem.appendChild(descriptionContainer);
        cardElem.addEventListener('dragstart', (e)=>{
            // Only allow drag if not editing description
            if (this.state.editingDescriptionCardId === null) e.dataTransfer?.setData('text/plain', card.id.toString());
            else e.preventDefault(); // Prevent drag while editing
        });
        // Mobile tap-to-select functionality
        cardElem.addEventListener('click', (e)=>{
            // Don't trigger if clicking on description (for editing) - but still allow selection
            if (e.target.classList.contains('card-description')) {
                // Also select the card when tapping the description area
                this.toggleCardSelection(card.id);
                return;
            }
            this.toggleCardSelection(card.id);
        });
        // Add selected class if this card is selected
        if (this.selectedCardId === card.id) cardElem.classList.add('selected');
        return cardElem;
    }
    // Toggle card selection for mobile
    toggleCardSelection(cardId) {
        if (this.selectedCardId === cardId) // Deselect if already selected
        this.selectedCardId = null;
        else this.selectedCardId = cardId;
        this.render();
    }
    // Render the UI based on the current state.
    render() {
        // Manage tabindex for global controls based on current part
        const isPart4Active = this.state.currentPart === 'part4';
        const globalControls = document.querySelectorAll('#global-controls button');
        globalControls.forEach((btn)=>{
            if (isPart4Active) btn.tabIndex = -1; // Make header buttons non-tabbable during Part 4
            else btn.removeAttribute('tabindex'); // Restore default tabbability
        });
        // Hide all parts first.
        document.querySelectorAll('.exercise-part').forEach((section)=>{
            section.style.display = 'none';
        });
        // Show the current part.
        const partElem = document.getElementById(this.state.currentPart);
        if (partElem) partElem.style.display = 'block';
        // Render cards for the current part.
        if (this.state.currentPart === 'part1') {
            // Clear containers for Part 1
            [
                'part1-unassignedContainer',
                'part1-veryImportantContainer',
                'part1-importantContainer',
                'part1-notImportantContainer'
            ].forEach((id)=>{
                const container = document.getElementById(id);
                if (container) container.innerHTML = '';
            });
            // Render each card into its Part 1 container.
            this.state.cards.forEach((card)=>{
                const containerId = 'part1-' + card.column + 'Container'; // Use Part 1 prefix
                const container = document.getElementById(containerId);
                if (container) {
                    const cardElem = this.createCardElement(card); // Use helper
                    container.appendChild(cardElem);
                }
            });
        } else if (this.state.currentPart === 'part2') {
            // Clear containers for Part 2
            [
                'part2-unassignedContainer',
                'part2-veryImportantContainer',
                'part2-importantContainer',
                'part2-notImportantContainer'
            ].forEach((id)=>{
                const container = document.getElementById(id);
                if (container) container.innerHTML = '';
            });
            // Log the state for debugging (can be removed later)
            // console.log("Rendering Part 2:", {
            //   totalCards: this.state.cards.length,
            //   cards: this.state.cards.map(c => ({ name: c.name, column: c.column }))
            // });
            // In Part 2, show all cards in their current Part 2 columns
            this.state.cards.forEach((card)=>{
                const containerId = 'part2-' + card.column + 'Container'; // Use Part 2 prefix
                const container = document.getElementById(containerId);
                if (container) {
                    const cardElem = this.createCardElement(card); // Use helper
                    container.appendChild(cardElem);
                }
            });
        } else if (this.state.currentPart === 'part3') {
            // Clear containers for part3
            [
                'coreContainer',
                'additionalContainer'
            ].forEach((id)=>{
                const container = document.getElementById(id);
                if (container) container.innerHTML = '';
            });
            this.state.cards.forEach((card)=>{
                if (card.column === 'core' || card.column === 'additional') {
                    const containerId = card.column + 'Container';
                    const container = document.getElementById(containerId);
                    if (container) {
                        const cardElem = this.createCardElement(card); // Use helper
                        container.appendChild(cardElem);
                    }
                }
            });
        } else if (this.state.currentPart === 'part4') {
            // Render text inputs for each core value.
            const finalStatementsContainer = document.getElementById('finalStatements');
            if (finalStatementsContainer) {
                const coreCards = this.state.cards.filter((c)=>c.column === 'core');
                coreCards.sort((a, b)=>a.name.localeCompare(b.name)); // Keep sorting for consistent order
                // Check if inputs matching core cards already exist
                const existingInputs = finalStatementsContainer.querySelectorAll('input[type="text"]');
                let inputsMatch = existingInputs.length === coreCards.length;
                if (inputsMatch) existingInputs.forEach((input, index)=>{
                    // Verify the input corresponds to the correct card (using id or other attribute if needed)
                    // For simplicity, we assume order matches due to sorting if length is correct
                    if (coreCards[index]?.id.toString() !== input.id.replace('statement-', '')) inputsMatch = false;
                });
                if (inputsMatch) // Inputs exist and match: Just update their values
                existingInputs.forEach((input)=>{
                    const cardId = Number(input.id.replace('statement-', ''));
                    const currentValue = this.state.finalStatements[cardId] ?? '';
                    if (input.value !== currentValue) input.value = currentValue;
                });
                else {
                    // Inputs don't exist or don't match: Clear and recreate them
                    finalStatementsContainer.innerHTML = '';
                    coreCards.forEach((card)=>{
                        const wrapper = document.createElement('div');
                        wrapper.className = 'final-statement';
                        const label = document.createElement('label');
                        label.htmlFor = `statement-${card.id}`;
                        label.textContent = `Describe what "${card.name}" means to you:`;
                        const input = document.createElement('input');
                        input.type = 'text';
                        input.id = `statement-${card.id}`;
                        input.value = this.state.finalStatements[card.id] ?? '';
                        // Use 'blur' event to update state directly when field loses focus
                        input.addEventListener('blur', ()=>{
                            const currentState = this.undoManager.getState(); // Get latest state
                            // Avoid modifying the state if it hasn't actually changed
                            if (currentState.finalStatements[card.id] !== input.value) {
                                const newState = this.undoManager.getState(); // Get a fresh copy to modify
                                newState.finalStatements[card.id] = input.value;
                                this.updateState(newState); // Update authoritative state
                            }
                        });
                        wrapper.appendChild(label);
                        wrapper.appendChild(input);
                        finalStatementsContainer.appendChild(wrapper);
                    });
                }
            }
        } else if (this.state.currentPart === 'review') {
            const reviewContent = document.getElementById('reviewContent');
            if (reviewContent) {
                reviewContent.innerHTML = '';
                // Add the visualization grid
                const grid = document.createElement('div');
                grid.className = 'values-grid';
                // Create sections for core values and additional values
                const categories = [
                    {
                        title: 'Core Values (F*CK YEAH)',
                        column: 'core'
                    },
                    {
                        title: 'Also Something I Want',
                        column: 'additional'
                    }
                ];
                categories.forEach((category)=>{
                    const section = document.createElement('div');
                    section.className = 'grid-section';
                    const title = document.createElement('h3');
                    title.textContent = category.title;
                    section.appendChild(title);
                    // Get the actual card objects, not just names
                    const cardsInCategory = this.state.cards.filter((c)=>c.column === category.column);
                    // Sort them alphabetically by name for consistent display
                    cardsInCategory.sort((a, b)=>a.name.localeCompare(b.name));
                    if (cardsInCategory.length > 0) {
                        const list = document.createElement('ul');
                        // Iterate over the card objects
                        cardsInCategory.forEach((card)=>{
                            const li = document.createElement('li');
                            const nameSpan = document.createElement('span');
                            nameSpan.className = 'review-value-name';
                            nameSpan.textContent = card.name; // Use name from card object
                            const descSpan = document.createElement('span');
                            descSpan.className = 'review-value-description';
                            // Prioritize card.description, fall back to map
                            descSpan.textContent = card.description ?? $543d6d2a56ed7d8d$var$valueDefinitionsMap.get(card.name) ?? '(Description missing)';
                            li.appendChild(nameSpan);
                            li.appendChild(descSpan);
                            list.appendChild(li);
                        });
                        section.appendChild(list);
                    }
                    grid.appendChild(section);
                });
                reviewContent.appendChild(grid);
                // Add the final statements
                const title = document.createElement('h3');
                title.textContent = 'Your Core Values & Statements:';
                reviewContent.appendChild(title);
                const list = document.createElement('ul');
                const coreCards = this.state.cards.filter((c)=>c.column === 'core');
                coreCards.forEach((card)=>{
                    const li = document.createElement('li');
                    const statement = this.state.finalStatements[card.id] ?? '(No statement written)';
                    li.textContent = `${statement} (${card.name})`;
                    list.appendChild(li);
                });
                reviewContent.appendChild(list);
            }
        }
        // Update visual state for mobile selection
        const allContainers = document.querySelectorAll('.card-container');
        allContainers.forEach((container)=>{
            if (this.selectedCardId !== null) container.classList.add('can-receive');
            else container.classList.remove('can-receive');
        });
        // Update progress stepper
        this.updateProgressStepper();
        // -- Update toggle button appearance based on current state --
        const limitedBtn = document.getElementById('useLimitedValuesBtn');
        if (limitedBtn) {
            // Update button text to reflect current mode
            if (this.state.valueSet === 'limited') {
                limitedBtn.textContent = 'Use All Values';
                limitedBtn.classList.add('active');
            } else {
                limitedBtn.textContent = 'Use 10 Values';
                limitedBtn.classList.remove('active');
            }
        }
    }
    // Update the disabled state of the undo/redo buttons.
    updateUndoRedoButtons() {
        const undoBtn = document.getElementById('undoBtn');
        const redoBtn = document.getElementById('redoBtn');
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (undoBtn) undoBtn.disabled = !this.undoManager.canUndo();
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (redoBtn) redoBtn.disabled = !this.undoManager.canRedo();
    }
    // Update the progress stepper UI
    updateProgressStepper() {
        const steps = [
            'part1',
            'part2',
            'part3',
            'part4',
            'review'
        ];
        const currentIndex = steps.indexOf(this.state.currentPart);
        const stepElements = document.querySelectorAll('.step');
        const connectors = document.querySelectorAll('.step-connector');
        stepElements.forEach((stepEl, index)=>{
            stepEl.classList.remove('active', 'completed');
            if (index === currentIndex) stepEl.classList.add('active');
            else if (index < currentIndex) stepEl.classList.add('completed');
        });
        connectors.forEach((connector, index)=>{
            connector.classList.remove('completed');
            if (index < currentIndex) connector.classList.add('completed');
        });
    }
}
// Initialize the app normally, only if in a browser environment
if (typeof window !== 'undefined' && typeof document !== 'undefined') window.addEventListener('DOMContentLoaded', ()=>{
    new $543d6d2a56ed7d8d$export$86fbec116b87613f();
});


//# sourceMappingURL=path0.b423caae.js.map
